import { motion } from "framer-motion";
import { Lightbulb, Rocket, TrendingUp } from "lucide-react";

const steps = [
  {
    icon: Lightbulb,
    number: "01",
    title: "Strategy",
    text: "We review your clinic, market, Google presence, website, reviews, content, and patient journey to identify where visibility, trust, and conversion are breaking down.",
  },
  {
    icon: Rocket,
    number: "02",
    title: "Execution",
    text: "We build and improve the marketing systems that support growth, including local SEO, Google visibility, content, reputation, patient education, and conversion-focused messaging.",
  },
  {
    icon: TrendingUp,
    number: "03",
    title: "Growth",
    text: "We track results, improve what is working, and help your clinic turn more attention into scheduled patients over time.",
  },
];

const ProcessSection = () => {
  return (
    <section id="process" className="section-padding section-gray">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-primary font-semibold tracking-[0.2em] uppercase text-sm mb-4">
            How It Works
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl mb-4 text-graphite">
            A Simple <span className="gold-gradient-text">3-Step System</span> for Growth
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            No guesswork. No random tactics. Just a clear process that turns your marketing into a patient growth system.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="relative"
            >
              <div className="card-glass-light p-8 h-full">
                <span className="text-5xl font-heading font-bold text-primary/15 absolute top-4 right-6">{step.number}</span>
                <step.icon className="w-10 h-10 text-primary mb-5" />
                <h3 className="font-heading text-2xl mb-3 text-graphite">{step.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{step.text}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-primary/30" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
